module.exports = __webpack_public_path__ + "static/media/blake.b489f32a.jpg";